module.exports = __webpack_public_path__ + "static/media/jeongseok.5c7e136e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/jeongseok.mp3
// module id = 97
// module chunks = 0